import { ProfileAPIService } from './AxiosAPIService';
import {
  SearchResponse,
} from '../types/Search';

const SEARCH_ENDPOINT = '/fleets';

export const getGlobalSearch = async (
  fleetId: string,
  query: string,
): Promise<SearchResponse> => {
  const { data } = await ProfileAPIService.api
    .get<SearchResponse>(`${SEARCH_ENDPOINT}/${fleetId}/global-search${query}`);
  return data;
};
